import { render, staticRenderFns } from "./PhoColorPickerInput.vue?vue&type=template&id=11eabab6&lang=pug"
import script from "./PhoColorPickerInput.vue?vue&type=script&lang=js"
export * from "./PhoColorPickerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports